module.exports = __webpack_public_path__ + "img/download-bg.09eae08e.png";